import * as React from "react"
import styled from "@digits-css"
import { LogoLoading } from "@digits-shared/components/Loaders/Page"
import { MetaTags } from "@digits-shared/components/MetaTags/MetaTags"
import colors from "@digits-shared/themes/colors"

export const ModuleLoadingStyled = styled.div`
  flex-grow: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${colors.secondary};
`

export const ModuleLoading: React.FC<{ className?: string }> = ({ className }) => (
  <ModuleLoadingStyled className={className}>
    <LogoLoading size="60px" />
  </ModuleLoadingStyled>
)

export const SpringboardModuleLoading: React.FC<{ className?: string }> = ({ className }) => (
  <>
    <MetaTags>
      <meta name="theme-color" content="#B8D2E5" />
    </MetaTags>
    <ModuleLoadingStyled className={className}>
      <LogoLoading size="60px" />
    </ModuleLoadingStyled>
  </>
)
